module.exports = __webpack_public_path__ + "static/media/HEIDI_SITE.9fb095b4.jpg";